import React, { useState } from "react";
import { EventKey } from "../../eventLogger/EventKeys";
import { itx } from "../../translationItx/itx";

export default function TreeMenuIcon(props: {
  iconName?: string;
  icon?: React.ReactNode;
  onClick: any;
  tooltipText?: string;
  tooltipKey?: string;
  objName: string;
  style?: any;
}) {
  const { iconName, icon, onClick, tooltipText, tooltipKey, objName, style } = props;

  // const redraw = useRedraw();

  const [x, setX] = useState(0);

  // const lastLanguage = useRef<string | undefined>();

  // useEffect(() => {
  //   const t = setInterval(() => {
  //     if (state.settings.language != lastLanguage.current) {
  //       lastLanguage.current = state.settings.language;
  //       // redraw();
  //     }
  //   }, 1000);
  // }, []);

  const defaultIconStyle: any = {
    width: "1em",
    height: "1em",
    alignSelf: "stretch", // no itx
  };

  const showMenuButtonTooltips = state.settings.showMenuButtonTooltips;
  let tooltipTextTanslated: any = tooltipText;
  if (tooltipKey) {
    // lastLanguage.current = undefined;
    tooltipTextTanslated = state.translate(`${tooltipKey}`, "");
    if (tooltipTextTanslated == "") {
      tooltipTextTanslated = `<span style="color: red;">${tooltipKey}</span>`;
    }
  }

  return (
    <div
      id={tooltipKey?.replaceAll(".", "_")}
      key={props.iconName + objName}
      className="treeMenuIcon"
      onMouseDown={(ev) => {
        if (ev.button !== 0) return;
        // Der Fokus auf der Elternzeile würde deren Referenzen samt Button vor
        // mouseup/click neu erzeugen. Die Aktion braucht keinen Zeilenfokus.
        ev.preventDefault();
        ev.stopPropagation();
        if (iconName === "external-link-alt") console.log("[NavigatorDebug] Navigate-to button: mousedown");
      }}
      onClick={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (iconName === "external-link-alt") console.log("[NavigatorDebug] Navigate-to button: click");

        state.track(`Treemenu | ${tooltipTextTanslated} | ${objName}`);
        let menukey = tooltipKey ?? iconName ?? objName;
        if (menukey?.includes(".")) {
          menukey = itx(menukey, menukey);
        }
        state.eventLogger.addEvent(EventKey.NavigatorMenuItemClicked, {
          menuId: menukey,
          contextobj: undefined,
        });
        onClick(ev);
      }}
      data-tooltip-id={showMenuButtonTooltips ? "tv-tooltip" : undefined}
      data-tooltip-html={showMenuButtonTooltips && tooltipTextTanslated ? tooltipTextTanslated : ""}
      data-tooltip-place={"bottom-end"} // no itx
      style={style}
    >
      {icon || <i style={{ color: style?.color || "inherit" }} className={`las la-${iconName}`}></i>}

      {/* <div className="menuButtonText">{tooltipText}</div> */}
    </div>
  );
}
